export default __webpack_public_path__ + "static/media/480_portfolio04-fr-web.277b6618.png";